import { asyncConnect } from 'redux-connect';
import { loadStats } from 'redux/modules/stats';
import loadable from '@loadable/component';

const WhyUseTwineBase = loadable(() => import('./WhyUseTwineBase'));

const WhyUseTwine = asyncConnect(
  [
    {
      promise: ({ store: { dispatch, getState } }) => {
        const promises = [];

        if (!getState().stats.loadedStats) {
          promises.push(dispatch(loadStats()));
        }

        return Promise.all(promises);
      },
    },
  ],
  ({ stats }) => ({
    stats,
  }),
  {
    loadStats,
  }
)(WhyUseTwineBase);

export default WhyUseTwine;
